import { Meta } from '@/components/common';
import { Container } from '@/components/layout';
import {
  OncallPaging,
  RolloutSafety,
  SecuritySettings,
  SessionsDangerZone,
} from '@/components/features/settings';

/** Production Settings, in the design's order: groups of rows, then the red card. */
export function SettingsPage() {
  return (
    <>
      <Meta title="Settings" />

      <Container className="flex flex-col gap-4.5">
        <SecuritySettings />
        <RolloutSafety />
        <OncallPaging />
        <SessionsDangerZone />
      </Container>
    </>
  );
}
